module.exports = __webpack_public_path__ + "static/media/ic-remove.d1f53dc6.svg";